module.exports = __webpack_public_path__ + "img/13.c0ea96e3.png";